const ARROW_LEFT = `
<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M20.943 24.9427C20.4223 25.4634 19.5781 25.4634 19.0574 24.9427L11.0574 16.9427C10.5367 16.422 10.5367 15.5778 11.0574 15.0571L19.0574 7.05711C19.5781 6.53641 20.4223 6.53641 20.943 7.05711C21.4637 7.57781 21.4637 8.42203 20.943 8.94273L13.8858 15.9999L20.943 23.0571C21.4637 23.5778 21.4637 24.422 20.943 24.9427Z" stroke="none" />
</svg>`;

export default ARROW_LEFT;
